import * as React from "react";
function SvgCloseRound(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM7.05 8.11a.75.75 0 011.06-1.06L12 10.939l3.889-3.89a.75.75 0 111.06 1.061L13.06 12l3.89 3.889a.75.75 0 01-1.061 1.06l-3.89-3.889-3.889 3.89a.75.75 0 11-1.06-1.061l3.889-3.89-3.89-3.889z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCloseRound);
export default ForwardRef;
